import { Option } from '@webapp/types/common/option';

import SimpleArtist from '@common/types/artist/simple-artist';
import CatalogRelease from '@common/types/catalog/catalog-release';
import SimpleUser from '@common/types/user/simple-user';
import { isCatalogEntryLocked } from '../../store/catalog/selectors';

export const RELEASE_MENU_OPTIONS: Option[] = [
  { label: 'Edit Release', value: 'edit' },
  { label: 'Cancel Takedown', value: 'cancel-takedown' },
  { label: 'Upgrade Release', value: 'upgrade-release' },
  { label: 'Correct Artist Profile', value: 'correct-artist-profile' },
  { label: 'Copy Traclink', value: 'copy-traclink' },
  { label: 'Delete Release', value: 'cancel-release' },
  { label: 'Takedown', value: 'take-down' },
  { label: 'Cancel Takedown', value: 'cancel-take-down' },
  { label: 'Delete Release', value: 'delete-release' },
  { label: 'Manage Ownership', value: 'manage-ownership' },
];

export const getMenuOptions = (
  release: CatalogRelease,
  artist?: SimpleArtist,
  user?: SimpleUser
) => {
  if (isCatalogEntryLocked(release)) {
    return [];
  }
  if (release.featuring) {
    return RELEASE_MENU_OPTIONS.filter((option) => {
      return (
        option.value === 'copy-traclink' &&
        (release.status === 'approved' ||
          release.status === 'released' ||
          release.status === 'published')
      );
    });
  }
  return RELEASE_MENU_OPTIONS.filter((option) => {
    switch (option.value) {
      case 'edit':
        return (
          release.artist.id === artist?.id &&
          (release.status === 'draft' ||
            release.status === 'changes-needed' ||
            release.status === 'pending' ||
            release.status === 'approved' ||
            release.status === 'released' ||
            release.status === 'rejected' ||
            release.status === 'taken-down' ||
            release.status === 'published')
        );

      case 'take-down':
        return (
          release.artist.id === artist?.id &&
          (release.status === 'published' || release.status === 'released')
        );
      case 'cancel-take-down':
        return (
          release.artist.id === artist?.id &&
          release.status === 'takedown-pending'
        );
      case 'upgrade-release':
        return (
          release.artist.id === artist?.id &&
          (release.status === 'pending' ||
            release.status === 'approved' ||
            release.status === 'released')
        );
      case 'correct-artist-profile':
        return (
          release.artist.id === artist?.id &&
          release.status !== 'pending-processing'
        );
      case 'cancel-release':
        return (
          release.artist.id === artist?.id &&
          (release.status === 'pending' ||
            release.status === 'approved' ||
            release.status === 'released')
        );
      case 'cancel-takedown':
        return (
          release.artist.id === artist?.id &&
          release.status === 'pending-takedown'
        );
      case 'repair':
        return release.status !== 'draft' && release.artist.id === artist?.id;

      case 'copy-traclink':
        return (
          release.status === 'approved' ||
          release.status === 'released' ||
          release.status === 'published'
        );
      case 'delete-release':
        return (
          release.artist.id === artist?.id &&
          (release.status === 'taken-down' ||
            release.status === 'draft' ||
            release.status === 'rejected' ||
            release.status === 'changes-needed')
        );
      case 'manage-ownership':
        return release.ownerId === user?.id;
      default:
        return true;
    }
  });
};
